/**
 * @generated SignedSource<<5e547335e5bf4611399e4743d7e38e61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoPriority = "DEFAULT" | "HIGH" | "LOW" | "URGENT";
import { FragmentRefs } from "relay-runtime";
export type TodoEditPrioPopover_todo$data = {
  readonly id: string;
  readonly priority: TodoPriority;
  readonly " $fragmentSpreads": FragmentRefs<"useTodoEditSetPrio_todo">;
  readonly " $fragmentType": "TodoEditPrioPopover_todo";
};
export type TodoEditPrioPopover_todo$key = {
  readonly " $data"?: TodoEditPrioPopover_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditPrioPopover_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditPrioPopover_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priority",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useTodoEditSetPrio_todo"
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "87b86f8363e0b55393b12224112861ba";

export default node;
